export default{
    globalMgmt: {
        global: "Gestión de clientes globales",
        alarms: "Definiciones de alarma",
        history: "Histora",
        alarmPageTitle: "Definiciones de alarmas globales",
        alarmDetails: "Detalles de la alarma"
    }
}
